import { SettingOutlined } from '@ant-design/icons'
import { message, Popconfirm, Popover, Tabs } from 'antd'
import React, { useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import Button from '../../../../Components/Button'
import LoaderBox from '../../../../Components/LoaderBox/LoaderBox'
import ModalBox from '../../../../Components/ModalBox/ModalBox'
import TableBox from '../../../../Components/TableBox/TableBox'
import FilterLayout from '../../../../Layout/FilterLayout'
import TableLayout from '../../../../Layout/TableLayout'
import apiClient from '../../../../Util/apiClient'
import { GET_DATA, SET_DATA, validateAccess } from '../../../../Util/Util'
import Logs from '../../../Logs/Logs'
import BookingFilter from './BookingFilter'

const { TabPane } = Tabs

export default function Bookings() {
  const [bookings, setBookings] = useState([])
  const [tabKey, setTabKey] = useState(GET_DATA('bookings.tabKey') || 'Created')
  const [selectedRows, setSelectedRows] = useState([])
  const [loader, setLoader] = useState(false)
  const [viewLogs, setViewLogs] = useState(false)

  const history = useHistory()

  const getData = (params = {}) => {
    const filterCache = GET_DATA('bookings.filterData') || {}
    params = { ...filterCache, ...params }

    if (tabKey !== 'All') {
      params.status = tabKey
    } else {
      params.status = undefined
    }

    apiClient.get('bookings', { params }).then(({ status, data }) => {
      if (status === 200) {
        SET_DATA('bookings.filterData', { ...params, ...data.pageData })
        setBookings(data.result)
        setLoader(data.result.length > 0 ? false : 'No data found')
      }
    })
  }

  useEffect(() => {
    getData()
    SET_DATA('bookings.tabKey', tabKey)
  }, [tabKey])

  const onDelete = (id) => {
    apiClient.delete(`bookings/${id}`).then(({ status }) => {
      if (status === 204) {
        setBookings(bookings.filter((item) => item.id !== id))
      }
    })
  }

  const onSubmit = (bookingIds = selectedRows.map((val) => val.id)) => {
    apiClient.post('bookings/submit', { bookingIds }).then(({ status }) => {
      if (status === 200) {
        message.success('Bookings Sent')
        setBookings(bookings.filter((item) => !bookingIds.includes(item.id)))
        setSelectedRows([])
      }
    })
  }

  const tableActions = (row) => (
    <div className="action-buttons">
      <ul>
        {validateAccess('edit-booking') && (
          <li>
            <Link to={`/app/edit-booking/${row.id}`}>
              <i className="flaticon-edit-1" /> Edit
            </Link>
          </li>
        )}
        {validateAccess('edit-booking') && row.status === 'Created' && (
          <li>
            <Popconfirm title="Sure to delete?" onConfirm={() => onDelete(row.id)}>
              <Link to="#">
                <i className="flaticon-delete-2" /> Delete
              </Link>
            </Popconfirm>
          </li>
        )}
        {validateAccess('edit-booking') && row.status === 'Created' && (
          <li>
            <Link to="#" onClick={() => onSubmit([row.id])}>
              <i className="flaticon-tick-1" /> Submit
            </Link>
          </li>
        )}
        <li>
          <Link to="#" onClick={() => setViewLogs(row)}>
            <i className="flaticon-information" /> View Logs
          </Link>
        </li>
      </ul>
    </div>
  )

  const columns = [
    {
      title: 'Booking No',
      dataIndex: 'bookingNo',
      render: (v, r) => (
        <div onClick={() => history.push(`/app/bookings/${r.id}`)}>
          <a>{v}</a>
        </div>
      )
    },
    {
      title: 'Type',
      dataIndex: 'type'
    },
    {
      title: 'Client Name',
      dataIndex: 'clientName'
    },
    {
      title: 'Mail ID',
      dataIndex: 'email'
    },
    {
      title: 'Status',
      dataIndex: 'status'
    },
    {
      title: 'Action',
      dataIndex: 'custom_action',
      render: (text, row) => (
        <Popover placement="bottomRight" content={tableActions(row)} trigger="click">
          <div className="btn-group">
            <button type="button" className="btn glow dropdown-toggle">
              <SettingOutlined /> <span className="caret" />
            </button>
          </div>
        </Popover>
      )
    }
  ]

  return (
    <FilterLayout filterData={GET_DATA('bookings.filterData')} filter={<BookingFilter onSubmit={getData} />}>
      <ModalBox
        title="Booking Logs"
        visible={!!viewLogs}
        onCancel={() => setViewLogs(false)}
        footer={false}
        destroyOnClose>
        <Logs entityId={viewLogs?.id} entityType="Booking" />
      </ModalBox>
      <TableLayout
        title="Bookings Overview"
        exportUrl="bookings/export"
        detailed
        rightSection={
          selectedRows.length > 0 &&
          tabKey === 'Created' && (
            <Button variant="primary" onClick={() => onSubmit()}>
              Send for Approval
            </Button>
          )
        }>
        <Tabs activeKey={tabKey} onChange={setTabKey}>
          <TabPane tab="Created" key="Created" />
          <TabPane tab="Sent" key="Sent" />
          <TabPane tab="Received" key="Received" />
        </Tabs>
        {!loader && (
          <TableBox
            dataSource={bookings}
            columns={columns}
            onSelect={setSelectedRows}
            selectedRows={selectedRows}
            pageData={GET_DATA('bookings.filterData')}
            onChangePage={getData}
          />
        )}
        <LoaderBox loader={loader} />
      </TableLayout>
    </FilterLayout>
  )
}
